export default __webpack_public_path__ + "static/media/EmmanuelRomo.b21b242f.jpeg";